import { render, staticRenderFns } from "./MediaBlock.vue?vue&type=template&id=bc60ce5c&scoped=true"
import script from "./MediaBlock.vue?vue&type=script&lang=js"
export * from "./MediaBlock.vue?vue&type=script&lang=js"
import style0 from "./MediaBlock.vue?vue&type=style&index=0&id=bc60ce5c&prod&scoped=true&lang=scss"
import style1 from "./MediaBlock.vue?vue&type=style&index=1&id=bc60ce5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc60ce5c",
  null
  
)

export default component.exports